import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import {
    AsyncRequestQueue,
    DashNotificationsModule,
    useAsync,
} from 'UI-Dash-Commons-UI';
import UserGrowlComponent from './UserGrowlComponent';

const UserGrowlsComponent: React.FunctionComponent = () => {
    const queueRef = useRef<AsyncRequestQueue>(new AsyncRequestQueue());
    const queue = queueRef.current;
    const location = useLocation();
    const [pathname, setPathname] = React.useState<string>(location.pathname);
    const pollingInterval = 10 * 60 * 1000; // 10 minutes in milliseconds
    const [isInitialLoadComplete, setIsInitialLoadComplete] = React.useState<boolean>(false);

    const UserNotifications = useAsync({
        asyncFunction: DashNotificationsModule.managers.UserNotificationsManager.loadNotifications,
        initialState: [],
        successCallback: () => {
            if (!isInitialLoadComplete) {
                setIsInitialLoadComplete(true);
            }
        },
        errorCallback: () => {
            queue.clear();
            setTimeout(() => {
                queue.enqueue(() => UserNotifications.execute());
            }, 30000);
        }
    });

    useEffect(() => {
        queue.enqueue(() => UserNotifications.execute());
        const notificationsIntervalId = setInterval(() => {
            queue.enqueue(() => UserNotifications.execute());
        }, pollingInterval);

        return () => {
            queue.clear();
            clearInterval(notificationsIntervalId);
        }
    }, []);

    useEffect(() => {
        if (location.pathname !== pathname) {
            setPathname(location.pathname);
            queue.enqueue(() => UserNotifications.execute());
        }
    }, [location.pathname]);

    return (
        <>
            {UserNotifications.data?.filter((notification) => notification.isGrowl)?.map((notification) => {
                return <UserGrowlComponent
                    key={notification.id}
                    localStorageKey={notification.id.toString()}
                    text={notification.content}
                    link={notification.ctaUrl}
                    linkText={notification.ctaLabel}
                />
            })}
        </>
    );
};

export default UserGrowlsComponent;
